module.exports = require("/Users/markalope/alchemy/career/gatsby/gatsby-portfolio-site/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 307
// module chunks = 231608221292675